import { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { pl } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const FMT = "dd.MM.yyyy";

export function DateField({ value, onChange, invalid, placeholder = "wybierz datę", testId, allowPast = false }) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parse(value, FMT, new Date()) : null;
  const selected = parsed && isValid(parsed) ? parsed : undefined;
  const today = new Date(); today.setHours(0, 0, 0, 0);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          aria-invalid={invalid || undefined}
          className={`flex h-10 w-full items-center justify-between rounded-md border bg-background px-3 py-2 text-sm text-left transition-colors hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${invalid ? "border-brand-red" : "border-input"} ${value ? "" : "text-muted-foreground"}`}
        >
          {value || placeholder}
          <CalendarIcon size={15} className="text-muted-foreground shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={pl}
          weekStartsOn={1}
          selected={selected}
          defaultMonth={selected || today}
          disabled={allowPast ? undefined : { before: today }}
          onSelect={(d) => {
            onChange(d ? format(d, FMT) : "");
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
